
<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col cols="4">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id"
                                                 :setActive="true"
                                                 disabled
                                                 :validate-error="errors[0]"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <b-form-group :label="$t('course')" class="mb-1">
                        <ValidationProvider name="course_id" rules="required"
                                            v-slot="{ errors }">
                            <instructor-course-auto-complete v-model="form.course_id"
                                                             :semesterId="semesterId"
                                                             :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('teaching_staff')">
                        <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :validate-error="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="from_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('from_date')">
                            <b-form-input type="datetime-local" v-model="form.from_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="to_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('to_date')">
                            <b-form-input type="datetime-local" v-model="form.to_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" class="mt-2 mb-2">
                    <ValidationProvider name="content" rules="required" v-slot="{valid, errors}">
                        <ck-editor v-model="form.content"/>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="section_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('section_id')">
                            <lined-textarea v-model="form.section_ids" :nowrap="false" :disabled="false"
                                            :styles="{ height: '124px' }" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col> 
            </b-row>
        </ValidationObserver>
        <b-button variant="primary" @click="save">{{ $t('save').toUpper() }}</b-button>
    </div>
</template>
<script>

import LmsAnnouncementsService from "@/services/LmsAnnouncementsService";
import moment from "moment/moment";
import CkEditor from "@/components/interactive-fields/Ckeditor.vue";
import InstructorCourseAutoComplete from "@/components/interactive-fields/InstructorCourseAutoComplete.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";

export default {
    components: {
        LinedTextarea,
        InstructorCourseAutoComplete,
        CkEditor
    },
    props: {
        semesterId:{},
        sectionId:{},
        formId:{
            type:Number
        }
    },
    data() {
        return {
            form:{
                content:null,
                instructor_id:null,
                from_date:null,
                to_date:null,
                section_ids:null,
            },
            instructorValueObject: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData(){
            LmsAnnouncementsService.show(this.formId)
                .then(response=>{
                    let data =response.data.data
                    this.instructorValueObject = {
                        value: data.instructor_id,
                        text: data.instructor_name + ' - ' + data.instructor_surname
                    }
                    this.form={
                        content:data.content ? this.decodeHTMLEntities(data.content) : null,
                        course_id:data.course_id,
                        to_date:data.to_date,
                        from_date:data.from_date,
                        instructor_id:data.instructor_id,
                        section_ids:data.section_ids.join('\n'),
                        semester_id:data.semester_id,
                    }
                }).catch(err=>{
                this.showErrors(err)
            })

        },
        async  save() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid){
                const fromDate = moment(this.form.from_date).format('YYYY-MM-DD HH:mm:ss')
                const toDate   = moment(this.form.to_date).format('YYYY-MM-DD HH:mm:ss')

                const payload = {
                    semester_id: this.semesterId,
                    course_id: this.form.course_id,
                    instructor_id: this.form.instructor_id,
                    content: this.form.content,
                    from_date: fromDate,
                    to_date: toDate,
                    section_ids: this.form.section_ids
                        ? this.form.section_ids
                            .split('\n')
                            .filter(x => x.trim() !== '')
                            .map(x => parseInt(x.trim()))
                        : []
                }


                LmsAnnouncementsService.update(this.formId,payload)
                    .then(response=>{
                        this.$toast.success(response.data.message)
                        this.$emit('updateAnnouncementSuccess',true)

                    }).catch(err=>{
                    this.showErrors(err)
                })
            }

        }
    },

};
</script>
